<script>
    import AudioPlayButton from "./buttons/AudioPlayButton.svelte";

    import {createEventDispatcher} from "svelte";
    import FastForward from "./buttons/FastForward.svelte";
    import SwitchTrackButton from "./buttons/SwitchTrackButton.svelte";

    let dispatch = createEventDispatcher();
    export let isPlaying = false;
    export let showBack = false;
    export let showNext = false;
</script>

<div style="display: flex; justify-content: center; align-items: center">
    <div style="margin-right: 24px">
        {#if showBack}
            <SwitchTrackButton isBack on:click={() => dispatch("switchBackwards")}></SwitchTrackButton>
        {:else}
            <div style="width: 24px; height: 24px"></div>
        {/if}

    </div>
    <FastForward on:click={() => dispatch("fastBack")} isBack/>
    <div style="margin-left: 32px; margin-right: 32px">
        <AudioPlayButton isPlaying={isPlaying} on:click={() => dispatch("playClicked")}/>
    </div>
    <FastForward on:click={() => dispatch("fastForward")}/>
    <div style="margin-left: 24px">
        {#if showNext}
            <SwitchTrackButton on:click={() => dispatch("switchForward")}></SwitchTrackButton>
        {:else}
            <div style="width: 24px; height: 24px"></div>
        {/if}
    </div>
</div>
